module.exports = __webpack_public_path__ + "static/media/zenflow-logo-highlight.1a281a51.svg";